import React from "react";
import { TextArea as NessieTextArea, NessieThemeProvider } from "@classdojo/web";

export const TextArea = (props: React.ComponentProps<typeof NessieTextArea>) => {
  return (
    <NessieThemeProvider>
      <NessieTextArea {...props} />
    </NessieThemeProvider>
  );
};
